import { render, staticRenderFns } from "./Math.vue?vue&type=template&id=4e9da807&scoped=true&"
import script from "./Math.vue?vue&type=script&lang=js&"
export * from "./Math.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9da807",
  null
  
)

export default component.exports